import type { FC } from "react";
import type { AppIconProps } from "../IconTypes";

export const SaveIconDiskette: FC<AppIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33329 2.6665V5.33317H5.33329V2.6665M3.99996 2.6665H10.6666L13.3333 5.33317V11.9998C13.3333 12.3535 13.1928 12.6926 12.9428 12.9426C12.6927 13.1927 12.3536 13.3332 12 13.3332H3.99996C3.64634 13.3332 3.3072 13.1927 3.05715 12.9426C2.8071 12.6926 2.66663 12.3535 2.66663 11.9998V3.99984C2.66663 3.64622 2.8071 3.30708 3.05715 3.05703C3.3072 2.80698 3.64634 2.6665 3.99996 2.6665ZM6.66663 9.33317C6.66663 9.68679 6.8071 10.0259 7.05715 10.276C7.3072 10.526 7.64634 10.6665 7.99996 10.6665C8.35358 10.6665 8.69272 10.526 8.94277 10.276C9.19282 10.0259 9.33329 9.68679 9.33329 9.33317C9.33329 8.97955 9.19282 8.64041 8.94277 8.39036C8.69272 8.14031 8.35358 7.99984 7.99996 7.99984C7.64634 7.99984 7.3072 8.14031 7.05715 8.39036C6.8071 8.64041 6.66663 8.97955 6.66663 9.33317Z"
        stroke="#1D9F81" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
